import React from "react";

export default function VisionMissionPage() {
    return (
        <section className="vision-mission-page profil-section section">
            <div className="container">
                {/* Header */}
                <h2 className="section-title">Visi & Misi</h2>

                {/* Visi */}
                <h3>Visi</h3>
                <p>
                    Menjadi mitra terpercaya dalam menyediakan solusi sistem IT, Audio Visual, & Automation dan desain interior yang terintegrasi, memberikan pengalaman yang luar biasa bagi setiap klien.
                </p>

                {/* Misi */}
                <h3>Misi</h3>
                <ul>
                    <li>
                        Menghadirkan teknologi Sistem IT, Audio Visual, & Automation yang inovatif dan desain interior yang estetis.
                    </li>
                    <li>
                        Membantu klien merancang kebutuhan dengan produktif, nyaman, dan efisien melalui solusi terintegrasi.
                    </li>
                    <li>
                        Menyediakan layanan dukungan dan pemeliharaan untuk memastikan kualitas dan kepuasan klien.
                    </li>
                </ul>
            </div>
        </section>
    );
}